import axios from 'axios'
export default class SocialService {
  static getTweets(token,count) {
    return new Promise((fulfill, reject) => {
      axios.get(`/social/twitter-timeline/${count}`, {headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error => {
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }

}